module.exports = __webpack_public_path__ + "media/images/backleather-35a79a3a0b46366a1970086f279df5eb.jpg";